import { IStore } from 'redux/IStore';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
const { notifSend } = notifActions;
import {
	IManageArticleSettings,
	IManageArticleSettingsAction,
	IArticleSettings,
	ArticleSettings,
} from 'models/magazine/article/articlesettings';
import { IArticle } from 'models/magazine/article/article';

/** Action Types */
export const REQUEST_START: string = 'managearticlesettings/REQUEST_START';
export const REQUEST_FAILURE: string = 'managearticlesettings/REQUEST_FAILURE';
export const GET_ARTICLESETTINGS_SUCCESS: string = 'managearticlesettings/GET_ARTICLE_SUCCESS';
export const UPDATE_ARTICLESETTINGS_SUCCESS: string = 'managearticlesettings/UPDATE_ARTICLE_SUCCESS';
export const CLEAR_FORM_DATA: string = 'managearticlesettings/CLEAR_FORM_DATA';

/** Initial State */
const initialState: IManageArticleSettings = {
	isFetching: false,
	articleSettings: {
		listed: true,
		//commentsEnabled: false,
		onlyForMembers: false,
	},
};

/** Reducer */
export function articleSettingsReducer(state = initialState, action: IManageArticleSettingsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case GET_ARTICLESETTINGS_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				articleSettings: action.payload.articleSettings,
			});

		case UPDATE_ARTICLESETTINGS_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				articleSettings: action.payload.articleSettings,
			});

		case CLEAR_FORM_DATA:
			return Object.assign({}, state, {
				articleSettings: {
					listed: true,
					commentsEnabled: false,
					onlyForMembers: false,
				},
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getArticleSettings(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/' + id + '/Edit',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IArticle) => {
						const articleSettings = new ArticleSettings();
						articleSettings.id = res.id;
						//articleSettings.commentsEnabled = res.commentsEnabled;
						articleSettings.listed = res.listed;
						articleSettings.onlyForMembers = res.onlyForMembers;

						dispatch(getArticleSettingsSuccess(articleSettings));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator - update */
export function updateArticleSettings(articleSettings: IArticleSettings) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/' + articleSettings.id + '/SetSettings/',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
				body: JSON.stringify(articleSettings),
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(
						notifSend({
							message: i18n.t('Notification_Success_ArticleSettings_Updated'),
							kind: 'success',
							dismissAfter: 3000,
						}),
					);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IManageArticleSettingsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function requestFailure(message: any): IManageArticleSettingsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function getArticleSettingsSuccess(articleSettings: IArticleSettings): IManageArticleSettingsAction {
	return {
		type: GET_ARTICLESETTINGS_SUCCESS,
		payload: {
			articleSettings,
		},
	};
}

/** Action Creator */
export function updateArticleSuccess(articleSettings: IArticleSettings): IManageArticleSettingsAction {
	return {
		type: UPDATE_ARTICLESETTINGS_SUCCESS,
		payload: {
			articleSettings,
		},
	};
}

/** Action Creator */
export function clearFormData(): IManageArticleSettingsAction {
	return {
		type: CLEAR_FORM_DATA,
	};
}
